const services = [
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '営業支援業務',
    description: '企業様向けの包括的な営業支援サービス。新規開拓から既存顧客深耕まで、御社の営業活動をトータルでバックアップします。',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '営業支援コンサルティング',
    description: '営業プロセスの可視化・改善から、KPI設計、営業組織の最適化まで。データに基づいた戦略的アプローチで成果を最大化します。',
  },
  {
    icon: 'ri-presentation-line',
    title: '各種コンサルティング業務',
    description: '経営戦略、マーケティング、業務改善など、幅広い分野でのコンサルティングを提供。課題に合わせた最適なソリューションをご提案します。',
  },
  {
    icon: 'ri-user-star-line',
    title: '各種商材の営業代行',
    description: '経験豊富な営業プロフェッショナルが、お客様に代わって商材の営業活動を代行。コスト削減と売上向上を同時に実現します。',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    title: '各種商材の販売代行',
    description: '商材の販売チャネル開拓から販売実務までを一括代行。新たな販路拡大と収益向上を強力にサポートします。',
  },
  {
    icon: 'ri-code-box-line',
    title: 'システム・ソフトウェア開発',
    description: '企画から開発、制作、配信、保守・管理・運営・販売まで、システム開発の全工程をワンストップで提供。受託開発にも対応します。',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-18">
          <p className="text-primary-600 text-sm font-medium tracking-widest mb-3">SERVICES</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            事業内容
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            株式会社Ｄｒｅａｍは、営業支援を核とした多角的なビジネスソリューションを提供しています。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 transition-all duration-300 hover:border-primary-200 hover:bg-primary-50/30"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${service.icon} text-xl`} />
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}